"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ReactHTMLPicture = _interopRequireDefault(require("@micado-digital/react-htmlpicture/ReactHTMLPicture"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Image = function Image(_ref) {
  var media = _ref.media,
      mediaFormats = _ref.mediaFormats,
      path = _ref.path;
  return /*#__PURE__*/_react.default.createElement(_ReactHTMLPicture.default, {
    media: media,
    path: path,
    mediaFormats: mediaFormats
  });
};

Image.propTypes = {
  media: _propTypes.default.object,
  mediaFormats: _propTypes.default.object,
  path: _propTypes.default.string
};
var _default = Image;
exports.default = _default;